import {SubscriptionInfoModel} from './SubscriptionInfo.model';
import {DescriptionLineModel} from './DescriptionLine.model';
import {ImageModel} from './Image.model';
import {PhysicalPropertiesModel} from './PhysicalProperties.model';
import {UrlModel} from './Url.model';
import {DescriptionLine, ItemAttributes} from '@wix/auto_sdk_ecom_current-cart-v-2';
import {ModelContext} from '../../../types/app.types';

export class AttributesModel {
  public itemType: string;
  public image: ImageModel;
  public physicalProperties: PhysicalPropertiesModel;
  public url: UrlModel;
  public descriptionLines: DescriptionLineModel[];
  public subscriptionInfo?: SubscriptionInfoModel;

  constructor(params: AttributesModel) {
    this.itemType = params.itemType;
    this.image = params.image;
    this.physicalProperties = params.physicalProperties;
    this.url = params.url;
    this.descriptionLines = params.descriptionLines;
    this.subscriptionInfo = params.subscriptionInfo;
  }

  public static fromCartV1({
    shippable,
    itemType,
    url,
    image,
    descriptionLines,
    subscriptionInfo,
  }: {
    shippable?: boolean;
    itemType?: string;
    url?: UrlModel;
    image?: ImageModel;
    descriptionLines?: DescriptionLineModel[];
    subscriptionInfo?: SubscriptionInfoModel;
  }) {
    return new AttributesModel({
      itemType,
      image,
      url,
      physicalProperties: PhysicalPropertiesModel.fromCartV1({shippable}),
      descriptionLines,
      subscriptionInfo,
    });
  }

  public static fromCartV2(attributes: ItemAttributes, modelContext: ModelContext): AttributesModel {
    return new AttributesModel({
      itemType:
        attributes.itemType.preset.toLowerCase() ??
        /* istanbul ignore next */ attributes.itemType.custom?.toLowerCase(),
      image: attributes.image ? ImageModel.fromCartV2(attributes.image) : undefined,
      physicalProperties: PhysicalPropertiesModel.fromCartV2(attributes.physicalProperties),
      url: UrlModel.fromCartV2(attributes.url, modelContext),
      descriptionLines: (attributes.descriptionLines ?? []).map((descriptionLine: DescriptionLine) =>
        DescriptionLineModel.fromCartV2(descriptionLine)
      ),
      subscriptionInfo: SubscriptionInfoModel.fromCartV2(attributes.subscriptionInfo),
    });
  }
}
